import { EcomWrapperSdkImpl } from "./core/EcomWrapperSdk";
import { EcomWrapperEventListenerEnumsObj } from "./enums/EcomWrapperEventListenerEnum";
import { EcomWrapperEventTypeEnumsObj } from "./enums/EcomWrapperEventTypeEnum";
import { EcomWalletSdkEnumsObj } from "./enums/EcomWalletSdkEnum";
import { ApplePayButtonColorEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayButtonColorEnum";
import { ApplePayButtonTypeEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayButtonTypeEnum";
import { ApplePayEventListenerEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayEventListenerEnum";
import { ApplePayEventTypeEnumsObj } from "@payair/apple-pay-sdk/enums/ApplePayEventTypeEnum";
import { GooglePayButtonColorEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayButtonColorEnum";
import { GooglePayButtonSizeModeEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayButtonSizeModeEnum";
import { GooglePayButtonTypeEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayButtonTypeEnum";
import { GooglePayEventListenerEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayEventListenerEnum";
import { GooglePayEventTypeEnumsObj } from "@payair/google-pay-sdk/enums/GooglePayEventTypeEnum";
import { SamsungPayButtonColorEnumsObj } from "@payair/samsung-pay-sdk/enums/SamsungPayButtonColorEnum";
import { SamsungPayButtonTypeEnumsObj } from "@payair/samsung-pay-sdk/enums/SamsungPayButtonTypeEnum";
import { SamsungPayEventListenerEnumsObj } from "@payair/samsung-pay-sdk/enums/SamsungPayEventListenerEnum";
import { SamsungPayEventTypeEnumsObj } from "@payair/samsung-pay-sdk/enums/SamsungPayEventTypeEnum";
import { addGetVersionToWindow } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
import { SrciButtonColorEnumsObj } from "@payair/srci-sdk/enums/SrciButtonColorEnum";
import { SrciButtonSizeEnumsObj } from "@payair/srci-sdk/enums/SrciButtonSizeEnum";
import { SrciEventListenerEnumsObj } from "@payair/srci-sdk/enums/SrciEventListenerEnum";
import { SrciEventTypeEnumsObj } from "@payair/srci-sdk/enums/SrciEventTypeEnum";
/** @internal */ const MAIN_OBJECT_NAME = "payairEcomWrapperSdk";
/** @internal */ const SDK_OBJECT_NAME = "ecomWrapperSdk";
const ecomWrapperSdk = new EcomWrapperSdkImpl();
/*
  NOTE
  Added getVersion to window always. If user uses JS file, the object will be overwritten with proper getVersion,
  otherwise if using NPM this object will stay in the window object.
*/
/** @internal */ addGetVersionToWindow(MAIN_OBJECT_NAME, SDK_OBJECT_NAME, ecomWrapperSdk.getVersion);
const payairSrciEnums = {
    SrciEventListenerEnums: SrciEventListenerEnumsObj,
    SrciEventTypeEnums: SrciEventTypeEnumsObj,
    SrciButtonColorEnums: SrciButtonColorEnumsObj,
    SrciButtonSizeEnums: SrciButtonSizeEnumsObj,
};
const applePayEnums = {
    ApplePayButtonColorEnums: ApplePayButtonColorEnumsObj,
    ApplePayButtonTypeEnums: ApplePayButtonTypeEnumsObj,
    ApplePayEventListenerEnums: ApplePayEventListenerEnumsObj,
    ApplePayEventTypeEnums: ApplePayEventTypeEnumsObj,
};
const samsungPayEnums = {
    SamsungPayButtonColorEnums: SamsungPayButtonColorEnumsObj,
    SamsungPayButtonTypeEnums: SamsungPayButtonTypeEnumsObj,
    SamsungPayEventListenerEnums: SamsungPayEventListenerEnumsObj,
    SamsungPayEventTypeEnums: SamsungPayEventTypeEnumsObj,
};
const googlePayEnums = {
    GooglePayEventListenerEnums: GooglePayEventListenerEnumsObj,
    GooglePayEventTypeEnums: GooglePayEventTypeEnumsObj,
    GooglePayButtonColorEnums: GooglePayButtonColorEnumsObj,
    GooglePayButtonSizeModeEnums: GooglePayButtonSizeModeEnumsObj,
    GooglePayButtonTypeEnums: GooglePayButtonTypeEnumsObj,
};
const payairEcomWrapperSdk = {
    ecomWrapperSdk: ecomWrapperSdk,
    EcomWalletSdkEnums: EcomWalletSdkEnumsObj,
    EcomWrapperEventListenerEnums: EcomWrapperEventListenerEnumsObj,
    EcomWrapperEventTypeEnums: EcomWrapperEventTypeEnumsObj,
    PayairApplePayEnums: applePayEnums,
    PayairGooglePayEnums: googlePayEnums,
    PayairSamsungPayEnums: samsungPayEnums,
    PayairSrciEnums: payairSrciEnums,
};
export default payairEcomWrapperSdk;
